export default __webpack_public_path__ + "static/media/212-tile.a833775f.svg";